import { useState } from "react";
import api, { apiErrorMessage } from "@/lib/api";
import { toast } from "sonner";
import { btnDark, inputCls, labelCls } from "./shared";

const PROVINCES = ["Islamabad Capital Territory", "Punjab", "Khyber Pakhtunkhwa", "Azad Jammu and Kashmir", "Gilgit-Baltistan", "Sindh", "Balochistan"];
const YN = [["true", "Yes"], ["false", "No"]];

const STUDENT_Q = [
  { key: "study_level", label: "What are you applying to study?", opts: [["bachelor", "Bachelor"], ["master", "Master"], ["phd", "PhD"], ["studienkolleg", "Studienkolleg (preparatory year)"], ["language_course", "Language course only"]] },
  { key: "financing_method", label: "How will you prove financing?", opts: [["blocked_account", "Blocked account (Sperrkonto)"], ["sponsor_germany", "Sponsor in Germany (Verpflichtungserklärung)"], ["scholarship", "German/EU or HEC scholarship"]] },
  { key: "tuition_applicable", label: "Does your programme charge tuition fees?", yn: true },
  { key: "semester_started", label: "Has the semester already started?", yn: true },
  { key: "has_work_experience", label: "Do you have work experience?", yn: true },
  { key: "has_education_gap", label: "Is there a gap of more than 3 months in your education or work?", yn: true },
  { key: "aps_exempt", label: "Exempt from APS (PhD, German/EU public scholarship, or non-Pakistani school/degree)?", yn: true },
];
const SHORT_Q = [
  { key: "employment_status", label: "What is your current situation?", opts: [["employed", "Employed"], ["self_employed", "Self-employed / business owner"], ["student", "Student"], ["retired", "Retired"], ["unemployed", "Not working"]] },
  { key: "sponsored", label: "Does someone else pay for your trip?", yn: true },
];

export default function Situation({ caseId, visa, conditions, onSaved }) {
  const [c, setC] = useState(conditions || {});
  const [busy, setBusy] = useState(false);
  const questions = [{ key: "residence_province", label: "Province where you live", opts: PROVINCES.map((p) => [p, p]) },
    ...(visa === "national_student" ? STUDENT_Q : SHORT_Q),
    { key: "previous_refusal", label: "Have you ever been refused a visa?", yn: true }];
  const val = (q) => (q.yn ? (c[q.key] === undefined ? "" : String(c[q.key])) : c[q.key] || "");
  const set = (q, v) => setC({ ...c, [q.key]: q.yn ? v === "true" : v });
  const save = async () => {
    setBusy(true);
    try { await api.put(`/cases/${caseId}/conditions`, { conditions: c }); toast.success("Checklist updated for your situation"); onSaved(); }
    catch (e) { toast.error(apiErrorMessage(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <div data-testid="situation-panel" className="max-w-2xl">
      <p className="text-sm text-muted">Your answers decide which documents and forms apply to you. Change them any time — the checklist updates.</p>
      <div className="mt-5 space-y-5">
        {questions.map((q) => (
          <div key={q.key}>
            <label className={labelCls}>{q.label}</label>
            <select className={inputCls} value={val(q)} onChange={(e) => set(q, e.target.value)} data-testid={`sit-${q.key}`}>
              <option value="">Select…</option>
              {(q.yn ? YN : q.opts).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
            </select>
          </div>
        ))}
      </div>
      <button onClick={save} disabled={busy} className={`${btnDark} mt-6`} data-testid="sit-save">{busy ? "Saving…" : "Save and update checklist"}</button>
    </div>
  );
}
